import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Filter, Main } from 'Containers';
import { errorToast } from 'Common/ToastHelper';
import { TRANSACTION_HISTORY_REPORT_FORM_NAME } from 'Common/FormEnum';
import { resetForm, submitForm } from 'State/forms/actions';
import { DATE_FORMAT_FOR_SERVER } from 'Common/Constants';
import { LoadingPage, NotificationDialog } from 'Components';
import { GenericEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { BidGroupEnum, TransactionHistoryReportEnum } from 'Common/FieldEnum';
import {
  getAcctCategoryForCurrentSite,
  getBidGroupForCurrentSite,
  getItemGroupForCurrentSite,
  getVendorForCurrentSite,
} from 'State/filters/actions';
import { getIds } from 'Common/FormHelper';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { ReportGeneration } from 'Common/ObjectHelper';
import * as FilterSelector from 'State/filters/selectors';

import { TransactionHistoryReportContainer } from './TransactionHistoryReport';
import { getSites, getTxnItems, clearReportError } from '../state/actions';
import {
  printReportData,
  getTxnTypes,
  resetPrintResponse,
  clearPrintReportError,
} from '../../commonState/actions';
import {
  BASE_URL,
  INITIAL_VALUES,
  ItemCodeDescriptionChangeEnum,
  PRINT_API_URL,
} from '../helper';
import * as CommonPrintSelector from '../../commonState/selectors';
import * as TransactionHistorySelector from '../state/selectors';

import 'Styles/pages/reports/inventory/transactionhistoryreport.less';

class TransactionHistoryReport extends Component {
  static propTypes = {
    submitForm: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    getTxnItems: PropTypes.func.isRequired,
    getTxnTypes: PropTypes.func.isRequired,
    getSites: PropTypes.func.isRequired,
    printReportData: PropTypes.func.isRequired,
    resetPrintResponse: PropTypes.func.isRequired,
    getAcctCategoryForCurrentSite: PropTypes.func.isRequired,
    getBidGroupForCurrentSite: PropTypes.func.isRequired,
    getItemGroupForCurrentSite: PropTypes.func.isRequired,
    getVendorForCurrentSite: PropTypes.func.isRequired,
    clearReportError: PropTypes.func.isRequired,
    clearPrintReportError: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    loadingDropdownItemsError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    loadingTransactionTypesDataError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    loadingSitesDataError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    sitesData: PropTypes.array.isRequired,
    printLoading: PropTypes.bool,
    bidGroupDataError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    itemGroupDataError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    acctCategoryDataError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    vendorDataError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    printError: PropTypes.object,
    printData: PropTypes.string,
    emptyPrintResponse: PropTypes.string,
  };

  static defaultProps = {
    bidGroupDataError: null,
    itemGroupDataError: null,
    acctCategoryDataError: null,
    vendorDataError: null,
    printError: null,
    printData: '',
    emptyPrintResponse: '',
    loadingDropdownItemsError: null,
    loadingTransactionTypesDataError: null,
    loadingSitesDataError: null,
    printLoading: false,
  };


  static path = `${BASE_URL}`;
  reactTableRef = React.createRef();
  state = {
    showNoDataModal: false,
    selectedSites: [],
    initialSelectedSiteIds: [],
  };

  handleSubmit = values => {
    const { initialSelectedSiteIds, selectedSites } = this.state;
    const input = { ...values };
    const dataObjs =
      this.reactTableRef && this.reactTableRef.current
        ? this.reactTableRef.current.getResolvedState()
        : { sortedData: initialSelectedSiteIds };
    let sites = [];
    _.forEach(dataObjs.sortedData, obj => {
      if (obj._subRows) {
        const subRowSites = _.filter(
          obj._subRows,
          subObj => selectedSites.indexOf(subObj.Id) !== -1
        ).map(v => v.Id);
        sites = [...sites, ...subRowSites];
      } else {
        const id = obj.Id ? obj.Id : obj._original.Id;
        if (selectedSites.indexOf(id) !== -1) {
          sites.push(id);
        }
      }
    });

    delete input[TransactionHistoryReportEnum.ItemSortOptions];

    input[TransactionHistoryReportEnum.DateFrom] = moment(
      values[TransactionHistoryReportEnum.DateFrom]
    ).format(DATE_FORMAT_FOR_SERVER);
    input[TransactionHistoryReportEnum.DateTo] = moment(
      values[TransactionHistoryReportEnum.DateTo]
    ).format(DATE_FORMAT_FOR_SERVER);
    input[TransactionHistoryReportEnum.SiteIds] = sites;
    input[TransactionHistoryReportEnum.IsAllSitesSelected] =
      initialSelectedSiteIds.length === selectedSites.length;
    this.props.printReportData(PRINT_API_URL, input);
  };

  handleClickPrint = () => {
    this.props.submitForm(TRANSACTION_HISTORY_REPORT_FORM_NAME);
  };

  getMainProps = () => {
    const { printLoading } = this.props;
    return {
      toolbox: {
        rightButtons: [
          {
            content: 'Print',
            onClick: this.handleClickPrint,
            loading: printLoading,
          },
        ],
        shown: true,
      },
    };
  };

  componentDidMount() {
    const {
      getTxnItems,
      getTxnTypes,
      getBidGroupForCurrentSite,
      getItemGroupForCurrentSite,
      getAcctCategoryForCurrentSite,
      getVendorForCurrentSite,
      getSites,
    } = this.props;
    getTxnItems();
    getTxnTypes();
    getBidGroupForCurrentSite(BidGroupEnum.AllOnly);
    getItemGroupForCurrentSite();
    getAcctCategoryForCurrentSite();
    getVendorForCurrentSite();
    getSites().then(() => {
      const SiteIds = getIds(this.props.sitesData);
      this.setState({
        initialSelectedSiteIds: SiteIds,
        selectedSites: SiteIds,
      });
    });
  }

  componentWillUnmount() {
    toast.dismiss();
  }

  setSelectedSites = selectedSites => {
    this.setState({
      selectedSites,
    });
  };
  componentDidUpdate(prevProps) {
    const { printData, clearReportError, clearPrintReportError } = this.props;

    if (
      errorToast(this.props, prevProps, 'printError') ||
      errorToast(this.props, prevProps, 'loadingDropdownItemsError') ||
      errorToast(this.props, prevProps, 'loadingSitesDataError') ||
      errorToast(this.props, prevProps, 'loadingTransactionTypesDataError') ||
      errorToast(this.props, prevProps, 'bidGroupDataError') ||
      errorToast(this.props, prevProps, 'itemGroupDataError') ||
      errorToast(this.props, prevProps, 'acctCategoryDataError') ||
      errorToast(this.props, prevProps, 'vendorDataError')
    ) {
      clearReportError();
      clearPrintReportError();
    }
    if (printData && printData !== prevProps.printData) {
      ReportGeneration(printData, 'Transaction History Report');
      clearPrintReportError();
    }
  }

  clearFilter = () => {
    this.props.resetForm(TRANSACTION_HISTORY_REPORT_FORM_NAME);
  };

  handleNoDataDialog = () => {
    const { emptyPrintResponse, resetPrintResponse } = this.props;
    emptyPrintResponse === GenericEnum.EmptyString && resetPrintResponse();
  };

  render() {
    const { emptyPrintResponse, loading, loadingSitesData } = this.props;

    return loading ? (
      <LoadingPage />
    ) : (
      <Fragment>
        <Filter
          title={'Reports | Transaction History'}
          style={{
            width: 600,
          }}
        />
        <Main {...this.getMainProps()}>
          <TransactionHistoryReportContainer
            onSubmit={this.handleSubmit}
            initialValues={{
              ...INITIAL_VALUES,
              [TransactionHistoryReportEnum.ItemSortOptions]:
                ItemCodeDescriptionChangeEnum.ItemDescriptionFirst,
            }}
            initialSelectedSiteIds={this.state.initialSelectedSiteIds}
            setSelectedSites={this.setSelectedSites}
            selectedSites={this.state.selectedSites}
            loadingSitesData={loadingSitesData}
            reactTableRef={this.reactTableRef}
          />
        </Main>
        <NotificationDialog
          title={'Print Report'}
          showDialog={emptyPrintResponse === GenericEnum.EmptyString}
          message={'No data available.'}
          onOkClick={this.handleNoDataDialog}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  ownProps.setPageLevelDirty(
    getIsDirty(TRANSACTION_HISTORY_REPORT_FORM_NAME)(state)
  );

  return {
    loading:
      FilterSelector.getBidGroupDataLoading(state) ||
      FilterSelector.getItemGroupDataLoading(state) ||
      FilterSelector.getAcctCategoryDataLoading(state) ||
      FilterSelector.getVendorDataLoading(state) ||
      TransactionHistorySelector.getLoadingDropdownItems(state) ||
      CommonPrintSelector.getLoadingTransactionTypesData(state) ||
      TransactionHistorySelector.getLoadingSitesData(state),
    loadingDropdownItemsError: TransactionHistorySelector.getLoadingDropdownItemsError(
      state
    ),
    loadingTransactionTypesDataError: CommonPrintSelector.getLoadingTransactionTypesDataError(
      state
    ),
    loadingSitesDataError: TransactionHistorySelector.getLoadingSitesDataError(
      state
    ),
    sitesData: TransactionHistorySelector.getSitesData(state),

    bidGroupDataError: FilterSelector.getBidGroupDataError(state),
    itemGroupDataError: FilterSelector.getItemGroupDataError(state),
    acctCategoryDataError: FilterSelector.getAcctCategoryDataError(state),
    vendorDataError: FilterSelector.getVendorDataError(state),
    printError: CommonPrintSelector.getPrintError(state),
    printData: CommonPrintSelector.getPrintData(state),
    printLoading: CommonPrintSelector.getPrintLoading(state),
    emptyPrintResponse: TransactionHistorySelector.getEmptyPrintResponse(state),
  };
};

const mapDispatchToProps = {
  submitForm,
  resetForm,
  getTxnItems,
  getTxnTypes,
  getSites,
  printReportData,
  resetPrintResponse,
  getAcctCategoryForCurrentSite,
  getBidGroupForCurrentSite,
  getItemGroupForCurrentSite,
  getVendorForCurrentSite,
  clearReportError,
  clearPrintReportError,
};

export const TransactionHistoryReports = connect(
  mapStateToProps,
  mapDispatchToProps
)(TransactionHistoryReport);



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/transactionhistoryreport/containers/TransactionHistoryReportContainer.js